import { render } from "./LeaderBoard.vue?vue&type=template&id=014cf324&scoped=true"
import script from "./LeaderBoard.vue?vue&type=script&lang=js"
export * from "./LeaderBoard.vue?vue&type=script&lang=js"

import "./LeaderBoard.vue?vue&type=style&index=0&id=014cf324&scoped=true&lang=css"

import exportComponent from "/var/www/mobitel/quizgiri/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-014cf324"]])

export default __exports__